import { Experiment } from '@naturalcycles/shared'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { QuizModifier, removePageFromFlow } from '@src/app/util/quiz.util'
import { DefaultQuizSection, QuizSections } from '@src/typings/quiz.enum'
import { AppQuizEngineConfig, AppQuizFlow, QuizSignatureObject } from '@src/typings/quiz.model'

class ExpRemoveUspScreenQuiz implements QuizModifier<AppQuizEngineConfig> {
  public _shouldEnhance(obj: QuizSignatureObject): boolean {
    return obj.experiment[Experiment.QUIZ_REMOVE_USP_SCREEN] === 'test'
  }

  public enhanceEngineConfig(
    obj: QuizSignatureObject,
    config: AppQuizEngineConfig,
  ): AppQuizEngineConfig {
    if (!this._shouldEnhance(obj)) return config

    return config
  }

  public enhanceSections(obj: QuizSignatureObject, sections: QuizSections): QuizSections {
    if (!this._shouldEnhance(obj)) return sections

    return sections
  }

  public enhanceInitialFlow(obj: QuizSignatureObject, flow: AppQuizFlow): AppQuizFlow {
    if (!this._shouldEnhance(obj)) return flow

    return removePageFromFlow(flow, DefaultQuizSection.intro, QuizPage.usps)
  }

  public enhanceEntry(obj: QuizSignatureObject, entry: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return entry
    return entry
  }

  public enhanceExit(obj: QuizSignatureObject, exit: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return exit
    return exit
  }
}

export const expRemoveUspScreenABTest = new ExpRemoveUspScreenQuiz()
